/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
export default {
  // Anything with _Admin_ is only used on admin pages

  // ##### Time Module #####

  // Timecards
  // NEW
  View_Time_Admin_Timecards: 'View--Web.Time.Admin.Timecards',
  Add_Time_Admin_Timecards: 'Add--Web.Time.Admin.Timecards',
  Modify_Time_Admin_Timecards: 'Modify--Web.Time.Admin.Timecards',
  Delete_Time_Admin_Timecards: 'Delete--Web.Time.Admin.Timecards',
  // DEPRECATED
  View_Admin_Timecards: 'View--Web.Time.Admin.Timecards',
  Add_Admin_Timecards: 'Add--Web.Time.Admin.Timecards',
  Modify_Admin_Timecards: 'Modify--Web.Time.Admin.Timecards',
  Delete_Admin_Timecards: 'Delete--Web.Time.Admin.Timecards',

  // Pay Periods
  // NEW
  View_Time_Admin_PayPeriods: 'View--Web.Time.Admin.PayPeriods',
  Add_Time_Admin_PayPeriods: 'Add--Web.Time.Admin.PayPeriods',
  Modify_Time_Admin_PayPeriods: 'Modify--Web.Time.Admin.PayPeriods',
  Delete_Time_Admin_PayPeriods: 'Delete--Web.Time.Admin.PayPeriods',

  // Timesheet Approvers
  // NEW
  View_Time_Admin_TimesheetApprovers: 'View--Web.Time.Admin.TimesheetApprovers',
  Add_Time_Admin_TimesheetApprovers: 'Add--Web.Time.Admin.TimesheetApprovers',
  Modify_Time_Admin_TimesheetApprovers: 'Modify--Web.Time.Admin.TimesheetApprovers',
  Delete_Time_Admin_TimesheetApprovers: 'Delete--Web.Time.Admin.TimesheetApprovers',
  // DEPRECATED
  View_Admin_TimesheetApprovers: 'View--Web.Time.Admin.TimesheetApprovers',
  Add_Admin_TimesheetApprovers: 'Add--Web.Time.Admin.TimesheetApprovers',
  Modify_Admin_TimesheetApprovers: 'Modify--Web.Time.Admin.TimesheetApprovers',
  Delete_Admin_TimesheetApprovers: 'Delete--Web.Time.Admin.TimesheetApprovers',

  // Data
  // NEW
  View_Time_Admin_Data_HourInformationDetails: 'View--Web.Time.Admin.Data.HourInformationDetails',
  Modify_Time_Admin_Data_HourInformationDetails: 'Modify--Web.Time.Admin.Data.HourInformationDetails',
  // DEPRECATED
  View_Admin_Data_HourInformationDetails: 'View--Web.Time.Admin.Data.HourInformationDetails',
  Modify_Admin_Data_HourInformationDetails: 'Modify--Web.Time.Admin.Data.HourInformationDetails',

  // ##### Manufacturing Module #####
  // Receiving - NEW
  View_Manufacturing_ReceivePO: 'View--Web.Manufacturing.ReceivePO',
  Modify_Manufacturing_ReceivePO: 'Modify--Web.Manufacturing.ReceivePO',

  // ##### Admin #####
  // SystemSettings
  View_Admin_SystemSettings: 'View--Web.Admin.SystemSettings',
  Add_Admin_SystemSettings: 'Add--Web.Admin.SystemSettings',
  Modify_Admin_SystemSettings: 'Modify--Web.Admin.SystemSettings',
  Delete_Admin_SystemSettings: 'Delete--Web.Admin.SystemSettings',

  // Anything with _Legacy_ is shared with legacy TETO Desktop

  // ##### LEGACY #####
  // Pay Periods
  // DEPRECATED
  View_Legacy_fdlgEditPayPeriod: 'View--Web.Time.Admin.PayPeriods',
  Add_Legacy_fdlgEditPayPeriod: 'Add--Web.Time.Admin.PayPeriods',
  Modify_Legacy_fdlgEditPayPeriod: 'Modify--Web.Time.Admin.PayPeriods',
  Delete_Legacy_fdlgEditPayPeriod: 'Delete--Web.Time.Admin.PayPeriods',

  // Receiving
  // DEPRECATED
  View_Legacy_frmReceiving_Main: 'View--Web.Manufacturing.ReceivePO',
  Modify_Legacy_frmReceiving_Main: 'Modify--Web.Manufacturing.ReceivePO',

  // Reports
  View_Legacy_Reports_Receiving_Report: 'View--\\Reports\\Receiving Report.rpt',
  View_Legacy_Reports_Receiving_Labels: 'View--\\Reports\\Receiving Label.rpt',
  View_Legacy_Reports_Receiving_Report_By_PO_And_PackingSlip: 'View--rptReceiving_POInspection_ByPackingSlipNumber',

  // ----------------------------------------------------------------------------

  // Anything with _MyTimeTracker_ is only used in MyTimeTracker
  // Timecards
  // NEW
  View_Time_Client_Timecards: 'View--Web.Time.Client.Timecards',
  Add_Time_Client_Timecards: 'Add--Web.Time.Client.Timecards',
  Modify_Time_Client_Timecards: 'Modify--Web.Time.Client.Timecards',
  Delete_Time_Client_Timecards: 'Delete--Web.Time.Client.Timecards',
  // DEPRECATED
  View_MyTimeTracker_Timecards: 'View--Web.Time.Client.Timecards',
  Add_MyTimeTracker_Timecards: 'Add--Web.Time.Client.Timecards',
  Modify_MyTimeTracker_Timecards: 'Modify--Web.Time.Client.Timecards',
  Delete_MyTimeTracker_Timecards: 'Delete--Web.Time.Client.Timecards',

  // Punchcards
  // NEW
  View_Time_Client_Punchcards: 'View--Web.Time.Client.Punchcards',
  Add_Time_Client_Punchcards: 'Add--Web.Time.Client.Punchcards',
  Modify_Time_Client_Punchcards: 'Modify--Web.Time.Client.Punchcards',
  Delete_Time_Client_Punchcards: 'Delete--Web.Time.Client.Punchcards',
  // DEPRECATED
  View_MyTimeTracker_Punchcards: 'View--Web.Time.Client.Punchcards',
  Add_MyTimeTracker_Punchcards: 'Add--Web.Time.Client.Punchcards',
  Modify_MyTimeTracker_Punchcards: 'Modify--Web.Time.Client.Punchcards',
  Delete_MyTimeTracker_Punchcards: 'Delete--Web.Time.Client.Punchcards',

  // View
  // NEW
  View_Time_Client_Display_HourInformationDetails: 'View--Web.Client.Display.HourInformationDetails',
  // DEPRECATED
  View_MyTimeTracker_Display_HourInformationDetails: 'View--Web.Client.Display.HourInformationDetails',

};
